/** The render parse of a GPUParticles3D: its instance state, its `visibility_aabb` and its `process_material` reference. */
import { parseOptionalAabb } from '../../../../parser/valueParsers';
import { GPU_PARTICLES_DEFAULT_VISIBILITY_AABB } from '../../../../godot/scene/gpuParticles';
import { parseGeometryInstance3D } from '../../geometryinstance3d/parser';
export function parseGPUParticles3D(heading, properties) {
    return {
        ...parseGeometryInstance3D(heading, properties),
        visibilityAabb: parseOptionalAabb(properties.visibility_aabb, 'visibility_aabb') ??
            GPU_PARTICLES_DEFAULT_VISIBILITY_AABB,
        processMaterial: properties.process_material,
    };
}
//# sourceMappingURL=parser.js.map